"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineObjectTypeStore = _interopRequireDefault(require("crm_data/flux/defineObjectTypeStore"));

var _CardsAPI = require("crm_ui/sidebar/layouts/api/CardsAPI");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _default = (0, _defineObjectTypeStore.default)({
  actionTypePrefix: 'CARDS',
  fetch: _CardsAPI.fetch
}).defineName('CardsStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;